import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageContext';
type PageHeroProps = {
  eyebrow: string;
  title: string;
  description: string;
  breadcrumb: string;
  image?: string;
};
export function PageHero({
  eyebrow,
  title,
  description,
  breadcrumb,
  image
}: PageHeroProps) {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full overflow-hidden bg-navy-950" data-id="element-305" data-mp="1cbt4dy84opsd">
      {image && <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" data-id="element-306" data-mp="17e11ya9uxl9x" />}
      <div className="absolute inset-0 bg-gradient-to-r from-navy-950 via-navy-950/90 to-navy-900/60" aria-hidden="true" data-id="element-307" data-mp="xg3gfujdu2l0" />
      <div className="relative mx-auto max-w-container px-6 py-20 lg:py-28" data-id="element-308" data-mp="3n2j7gjsrrztu">
        <nav aria-label={t.nav.breadcrumb} className="mb-8" data-id="element-309" data-mp="3i3zkcg2fwhzw">
          <ol className="flex items-center gap-2 text-[11px] uppercase tracking-[0.16em] text-navy-100/50" data-id="element-310" data-mp="2t3gxo2b18osd">
            <li data-id="element-311" data-mp="2y3d0vzbwoc6v">
              <Link to="/" className="transition-colors hover:text-gold" data-id="element-312" data-mp="2y1s74bxf0xa2">
                {t.nav.home}
              </Link>
            </li>
            <ChevronRightIcon className="h-3 w-3" aria-hidden="true" data-id="element-313" data-mp="2j86psxxydn6o" />
            <li className="text-gold" data-id="element-314" data-mp="2o3cf86qkdjzi">{breadcrumb}</li>
          </ol>
        </nav>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-315" data-mp="2acqs25u2unvt">
          <div className="flex items-center gap-4" data-id="element-316" data-mp="20g495mlba6wf">
            <span className="rule-gold" aria-hidden="true" data-id="element-317" data-mp="20d8ce1l79o9k" />
            <p className="eyebrow text-gold" data-id="element-318" data-mp="25f7e771akd4e">{eyebrow}</p>
          </div>
          <h1 className="mt-6 max-w-3xl font-display text-4xl font-medium leading-[1.1] text-white sm:text-5xl lg:text-6xl" data-id="element-319" data-mp="1re4qyqyk8wrw">
            {title}
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-navy-100/70 lg:text-lg" data-id="element-320" data-mp="1vicewlx728p2">
            {description}
          </p>
        </motion.div>
      </div>
    </section>;
}